export default __webpack_public_path__ + "static/media/ic_bulgaria.0babfef7.svg";